export default ($axios) => ({
    $axios,

    async fetch({
        client_id,
    }) {
        const localClientId = client_id ? `?client_id=${client_id}` : ''
        return await $axios.get(`/client_problem_messages${localClientId}`)
    },

    async add(form) {
        return await $axios.post('/client_problem_messages', form)
    },

    async fetchById(id) {
        return await $axios.get(`/client_problem_messages/${id}`)
    },

    async update(form) {
        return await $axios.put(`/client_problem_messages/${form.id}`, form)
    },

    async remove(id) {
        return await $axios.delete(`/client_problem_messages/${id}`)
    },
})
